import React, { Component } from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import Icon from "../../../common/icon/icon.component.jsx";

class QuoteApprovedEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            quote: this.props.quote || null,
            modal: '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            quote: nextProps.quote || null,
            proposal: nextProps.proposal || null,
        })
    }


    render() {
        return <div className={"row " + this.state.className}>
            <div className={'col-12 d-flex align-items-center'}>
                <div className={'mr-3'}>
                    <h3 className={"m-0 text-success"}>
                        <Icon value={"check-circle"} />
                    </h3>
                </div>
                <div >
                    <p className={'mb-0'}>
                        <FormattedMessage
                            id="quote.analytics.events.approved.text"
                            defaultMessage="Proposal {identifier} has been won for a total value of {value}"
                            values={{
                                identifier: <strong>{this.state.quote.attributes.identifier}</strong>,
                                value: <strong>
                                    <FormattedNumber
                                        value={this.state.quote.attributes.totalValue}
                                        style={'currency'}
                                        currency={this.state.quote.attributes.currency}
                                    />
                                </strong>,
                            }}
                        />
                    </p>
                </div>
            </div>
        </div>
    }

}

export default QuoteApprovedEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/quote-approved.component.jsx